// Nav entry of Free (shell/nav.ts collects every routes/*.nav.ts; `order` places it in the rail, the tabs and Lisää).
import { defineNav } from '../shell/nav-entry';

export const nav = defineNav({
  id: 'free',
  path: '/free',
  icon: 'free',
  group: 'practice',
  phone: 'more',
  session: true,
  order: 200,
  load: () => import('./Free'),
});
